module.exports = __webpack_public_path__ + "static/img/ANNEX.706bb1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/ANNEX.jpg
// module id = TTES
// module chunks = 0